module.exports = __webpack_public_path__ + "img/32-areader.40bf42f4.png";